import React from 'react';
import Image from 'next/image';
import WelcomeAppImage from '../../images/CheckoutConfirmation/WelcomeApp.png';
import { CtaButton } from '../../molecules';
import {
  StyledAppImageContainer,
  StyledContent,
  StyledHeadline,
  StyledTitle,
  StyledWelcomeToThePackContainer,
  StyledBody,
} from './styles';

export const WelcomeToThePack = () => {
  return (
    <StyledWelcomeToThePackContainer>
      <StyledAppImageContainer>
        <Image
          src={WelcomeAppImage}
          alt="Welcome To The Pack Image"
          width={96}
          height={188}
        />
      </StyledAppImageContainer>
      <StyledContent>
        <StyledHeadline>WELCOME TO THE PACK</StyledHeadline>
        <StyledTitle>Log into your new Ollie account</StyledTitle>
        <StyledBody>
          You’re amongst furry friends! Find more screenings, explore extras,
          and more in our app.
        </StyledBody>
        <CtaButton
          href="ollie://auth/login"
          minWidth={150}
          fullWidth
          hoverIcon=""
          variant="yam"
        >
          Login
        </CtaButton>
      </StyledContent>
    </StyledWelcomeToThePackContainer>
  );
};
